/**
 * Mapea la estructura que se encuentra en el archivo formulario-cliente.json
 */

 export class ParametrizacionVista {
  /**
   * Es ClienteService.TIPO_DOCUMENTO_NATURAL o ClienteService.TIPO_DOCUMENTO_JURIDICO
   */
  tipoTomador: string;

  // Estos son los nombres de los campos como se identifican en el formControlName de la vista
  // src\app\components\cliente\registro-cliente\registro-cliente.component.html
  // Si el nombre de campo está en alguna de estas listas entonces es visible en la vista.
  camposObligatorios: string[];
  camposOpcionales: string[];
}

export class ValidacionCliente {

    codigoProducto: string;
    // validaciones: string[];
    constructor() { }

    asignacionCampos: ParametrizacionVista[];
}



// WEBPACK FOOTER //
// ./src/app/models/cliente/validacion-cliente.class.ts